import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Grid2, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

interface QrCodeProps {
  qrData?: string;
}

export const QrCode = ({ qrData }: QrCodeProps) => {
  const { t } = useTranslation();

  if (!qrData) {
    return (
      <Grid2
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ height: '240px', width: '240px' }}
        spacing={2}
      >
        <CircularProgress />
        <Typography align="center" variant="caption">
          {t('channels:loadQrPlaceholder')}
        </Typography>
      </Grid2>
    );
  }

  return (
    <Box
      sx={{
        height: '240px',
        width: '240px',
      }}
    >
      <QRCodeSVG
        value={qrData}
        size={240}
        level="H"
        imageSettings={{
          src: '',
          height: 24,
          width: 24,
          excavate: true,
        }}
      />
    </Box>
  );
};
